import { render, staticRenderFns } from "./CashierGroups.vue?vue&type=template&id=1c84c2aa&scoped=true"
import script from "./CashierGroups.vue?vue&type=script&lang=ts"
export * from "./CashierGroups.vue?vue&type=script&lang=ts"
import style0 from "./CashierGroups.vue?vue&type=style&index=0&id=1c84c2aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84c2aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c84c2aa')) {
      api.createRecord('1c84c2aa', component.options)
    } else {
      api.reload('1c84c2aa', component.options)
    }
    module.hot.accept("./CashierGroups.vue?vue&type=template&id=1c84c2aa&scoped=true", function () {
      api.rerender('1c84c2aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/CashierGroups.vue"
export default component.exports